"use client";

import { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";

const LazyGridMaker = dynamic(() => import("./grid-maker"), {
  ssr: false,
  loading: () => (
    <div className="h-[400px] w-full animate-pulse rounded-lg bg-muted" />
  ),
});

const LazyToaster = dynamic(
  () => import("@/shared/components/ui/sonner").then((module) => module.Toaster),
  {
    ssr: false,
  }
);

export function GridMakerIsland() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const element = containerRef.current;
    if (!element || shouldLoad) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry?.isIntersecting) {
          return;
        }

        setShouldLoad(true);
        observer.disconnect();
      },
      {
        rootMargin: "300px 0px",
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [shouldLoad]);

  return (
    <div ref={containerRef}>
      {shouldLoad ? (
        <>
          <LazyGridMaker />
          <LazyToaster position="top-center" richColors />
        </>
      ) : (
        <div className="h-[400px] w-full animate-pulse rounded-lg bg-muted" />
      )}
    </div>
  );
}
